import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
import { getFullNameUser } from "@/js/user/user.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "CreditCardListComponent",
  props: ["isLoading", "stripe", "value", "clientSecret", "user", "list", "numberOfPaymentMethods"],
  data: function data() {
    return {
      isValid: false,
      errorMessage: null,
      card: null
    };
  },
  mounted: function mounted() {
    this.buildStripeInput();
  },
  watch: {
    stripe: function stripe() {
      this.buildStripeInput();
    }
  },
  components: {
    confirm: confirmationComponent
  },
  methods: {
    getFullNameUser: getFullNameUser,
    saveCreditCard: function saveCreditCard() {
      this.$EventBus.$emit("loading", true);
      var _this = this;
      this.stripe.confirmCardSetup(this.clientSecret, {
        payment_method: {
          card: this.card,
          type: "card",
          billing_details: {
            name: getFullNameUser(this.user),
            address: {
              postal_code: this.user.billing_address.zip
            }
          }
        }
      }).then(function (result) {
        var setupIntent = result.setupIntent;
        if (result.error) {
          _this.errorMessage = result.error.message;
          throw result.error;
        } else if (setupIntent.status === "requires_payment_method") {
          throw "Confirmation failed. Attempt again with a different card.";
        } else if (setupIntent.status === "succeeded") {
          request("/v1/stripe/payment-method", "post", {
            payment_method_id: result.setupIntent.payment_method,
            customerId: _this.user.id_user
          }, true, "api").then(function () {
            _this.$emit("card-saved");
          }).finally(function () {
            _this.$EventBus.$emit("loading", false);
            _this.card.clear();
          });
        }
      });
      _this.$EventBus.$emit("loading", false);
    },
    setDefaultPayment: function setDefaultPayment(creditCard) {
      this.$EventBus.$emit("loading", true);
      var _this = this;
      request("/v1/stripe/payment-method/".concat(creditCard.payment_method_id, "/default"), "put", {}, true, "api").then(function () {
        _this.$emit("card-updated");
      }).finally(function () {
        _this.$EventBus.$emit("loading", false);
      });
    },
    deleteCard: function deleteCard(payment_method_id) {
      var _this = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this credit card ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          _this.$EventBus.$emit("loading", true);
          request("/v1/stripe/payment-method/".concat(payment_method_id), "delete", null, true, "api").then(function () {
            _this.$emit("card-deleted");
          }).finally(function () {
            _this.$EventBus.$emit("loading", false);
          });
        }
      });
    },
    buildStripeInput: function buildStripeInput() {
      if (this.stripe) {
        var elements = this.stripe.elements({
          locale: "en"
        });
        this.card = elements.create("card", {
          hidePostalCode: true,
          iconStyle: "solid",
          style: {
            base: {
              padding: "20rem",
              textAlign: "center",
              color: "#000",
              iconColor: "#000",
              fontWeight: 500,
              fontSize: "16px",
              fontSmoothing: "antialiased",
              ":-webkit-autofill": {
                color: "#000"
              },
              "::placeholder": {
                color: "#CFD7DF"
              }
            },
            invalid: {
              color: "#FFC7EE",
              ":focus": {
                color: "#000"
              }
            }
          }
        });
        this.card.mount("#container-card");
        var _this = this;
        this.card.on("ready", function () {
          _this.card.focus();
        });
        this.card.on("change", function (e) {
          if (e.complete) {
            _this.$parent.$data.stripeErrorOccured = false;
            _this.$emit("input", 0);
            _this.isValid = true;
          } else {
            _this.isValid = false;
          }
          if (e.error) {
            _this.$emit("input", -1);
            _this.errorMessage = e.error.message;
          } else {
            _this.errorMessage = null;
          }
        });
      }
    }
  }
};